import * as React from 'react';

export type LoaderProps = {
	modifier?: string;
	customClasses?: string;
	hasContainer?: boolean;
};

export const Loader = ({ modifier, customClasses, hasContainer = true }: LoaderProps) => {
	const classNames = ['a-loader', 'js-a-loader'];

	if (modifier) {
		classNames.push(`a-loader--${modifier}`);
	}

	if (customClasses) {
		classNames.push(customClasses);
	}

	const loader = (
		<div className={classNames.join(' ')}>
			<div className="a-loader__wrap">
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
				<span className="a-loader__dot" />
			</div>
		</div>
	);

	if (!hasContainer) {
		return loader;
	}

	return <div className="container--loader">{loader}</div>;
};

Loader.displayName = 'Loader';

export default Loader;
